import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { commonPath } from '../fieldPath';

function DurationCounter({ cardEle, cardIndex, handleChange, modalState, addEditAccess }) {
  const { t } = useTranslation('common');

  return (
    <div className="collapse-card add-bom-accordion">
      <Accordion key={`Column_duration_${cardIndex}`}>
        <Card className="bom-add-card ">
          <Card.Header>
            <div className="align-items-center reducing-switch-z-index mr-16">
              <div className="d-inline-flex align-items-center design-switch">
                <input
                  type="checkbox"
                  className="form-check-input comment-switch-input"
                  disabled={cardEle?.dependentObj?.dependentSwitch}
                  id={`durationCounter_${cardIndex}`}
                  name={`durationCounter_${cardIndex}`}
                  onChange={(e) =>
                    !e?.target?.checked
                      ? handleChange(e?.target?.checked, commonPath(cardIndex, 'durationCounterSwitch').COMMON, cardIndex, [
                          'durationCounterSwitch',
                          'customDurations',
                        ])
                      : handleChange(e?.target?.checked, commonPath(cardIndex, 'durationCounterSwitch').COMMON, cardIndex)
                  }
                  checked={cardEle?.durationCounterSwitch}
                />
                <label className="switch-text font-heavy align-items-center mt-03" htmlFor={`durationCounter_${cardIndex}`}>
                  {t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.DURATION_COUNTER')}
                </label>
              </div>
            </div>
            <Accordion.Toggle className="btn-toggle text-decoration-none text-dark" as="button" variant="link">
              <span className="icon-new-down-arrow-icon" />
            </Accordion.Toggle>
          </Card.Header>
          {cardEle?.durationCounterSwitch && (
            <Card.Body>
              <div className="common-react-select">
                <p className="field-name">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.LINKED_COLUMN')}</p>
                <Select
                  name="durationlinkedColumnValue"
                  options={modalState?.dateTypeColumn}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  maxMenuHeight={140}
                  menuPosition="fixed"
                  value={cardEle?.durationlinkedColumnValue}
                  className="common-select"
                  classNamePrefix="common-select"
                  isClearable
                  onChange={(e) => handleChange(e, commonPath(cardIndex, 'durationlinkedColumnValue').COMMON, cardIndex)}
                  placeholder={t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.SELECT_COLUMN')}
                  isDisabled={!addEditAccess}
                  menuPlacement="bottom"
                  menuShouldBlockScroll
                  menuShouldScrollIntoView
                />
                {cardEle.hasError && !cardEle?.durationlinkedColumnValue && (
                  <span className="error-message">{t('PRODUCT_CRITICAL_PATH.MODAL.DEPENDENT_ACCORIDIAN.COLUMN_SELECTION_REQUIRED')}</span>
                )}
              </div>
            </Card.Body>
          )}
        </Card>
      </Accordion>
    </div>
  );
}
export default DurationCounter;
